module.exports = __webpack_public_path__ + "media/assets/svgs/notifications-4d3e56ae94dcabb42685ea6999c3e1ec.svg";